import { render } from "./AdvisoryProgrammDataTable.vue?vue&type=template&id=fa66cc8c&scoped=true"
import script from "./AdvisoryProgrammDataTable.vue?vue&type=script&lang=js"
export * from "./AdvisoryProgrammDataTable.vue?vue&type=script&lang=js"

import "./AdvisoryProgrammDataTable.vue?vue&type=style&index=0&id=fa66cc8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa66cc8c"]])

export default __exports__